export default {
  zoomToFit: 'Prispôsobiť zobrazenie',
  arrangeNodes: 'Usporiadať',
  zoomIn: 'Priblížiť',
  zoomOut: 'Oddialiť',
  more: 'Ďalšie funkcie',
  backgroundContextMenu: {
    addNode: {
      title: 'Pridať uzol',
      emitter: 'Emitor',
      function: 'Funkcia',
      operator: 'Operátor',
      variable: 'Premenná',
    },
    preview: {
      title: 'Náhľad',
      hideAll: 'Skryť všetky',
    },
  },
};
